module.exports = __webpack_public_path__ + "static/media/logo-horizontal-blanco.2403a333.svg";